<template>
  <div class="footer">
    Ⓒ EY-Parthenon 2020
  </div>
</template>

<script>
export default {
  name: 'Footer',
  props: { }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .footer {
    flex: 0 1 20px;
    border-top: 1px solid #4B4B4B;
    height: 20px;
    width:100%;
    white-space: nowrap;
    font-family: monospace;
    font-size: 12px;
    padding-left: 5px;
    position: fixed;
    left: 0;
    bottom: 0;
	background: white;
  }
</style>
